export default {
  'user.title.edit': {
    ko: '사용자 수정',
    ja: 'ユーザー修正',
    en: 'Edit User',
  },
  'user.montoringSystem': {
    ko: '모니터링 시스템',
    ja: 'モニタリングシステム',
    en: 'Montoring System',
  },
  'user.id': {
    ko: '아이디',
    ja: 'ID',
    en: 'ID',
  },
  'user.defaultSystem': {
    ko: '디폴트 시스템',
    ja: 'デフォルトシステム',
    en: 'Default System',
  },
  'user.timeZone': {
    ko: '타임존',
    ja: 'タイムゾーン',
    en: 'Time zone',
  },
  'user.name': {
    ko: '이름',
    ja: '名前',
    en: 'Name',
  },
  'user.password': {
    ko: '비밀번호',
    ja: 'パスワード',
    en: 'Password',
  },
  'user.role.user': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
  },
  'user.role': {
    ko: '권한',
    ja: '権限',
    en: 'Role',
  },
  'user.phoneNumber': {
    ko: '연락처',
    ja: '連絡先',
    en: 'Phone Number',
  },
  'user.role.admin': {
    ko: '관리자',
    ja: '管理者',
    en: 'Admin',
  },
  'user.title.add': {
    ko: '사용자 추가',
    ja: 'ユーザー追加',
    en: 'Add User',
  },
  'user.confirmPassword': {
    ko: '비밀번호 확인',
    ja: 'パスワード確認',
    en: 'Password',
  },
  'user.email': {
    ko: '이메일',
    ja: '電子メール',
    en: 'E-mail',
  },
  'user.push.id': {
    ko: '푸시서버 아이디',
    ja: 'プッシュサーバーID',
    en: 'Push server ID',
  },
  // BEGIN::Added.by.KWShin.2026.07.15.
  'user.menu.settings': {
    ko: '메뉴 접근 권한 설정',
    ja: 'メニュー権限設定',
    en: 'Menu access control',
  },
  // FINISH::Added.by.KWShin.2026.07.15.
};
